import { h } from 'preact';
import styles from './ActiveFilters.module.scss';
export function ActiveFilters({ filters, onRemoveFilter, onRemoveAllFilters, }) {
    const activeFilters = filters.reduce((acc, filter) => {
        var _a, _b, _c;
        if (filter.type === 'range' &&
            (filter.id === 'price' || filter.id === 'pf_p_price')) {
            const priceFilter = (_a = filter.options) === null || _a === void 0 ? void 0 : _a.find((opt) => opt.selected);
            if (priceFilter) {
                const [min, max] = priceFilter.id.split(',').map(Number);
                acc.push({
                    filterId: filter.id,
                    filterLabel: filter.label,
                    value: priceFilter.id,
                    valueLabel: `$${min} - $${max}`,
                });
            }
        }
        else if (filter.type === 'rating') {
            const selectedOptions = ((_b = filter.options) === null || _b === void 0 ? void 0 : _b.filter((opt) => opt.selected)) || [];
            selectedOptions.forEach((option) => {
                let starCount = 1;
                if (option.rating) {
                    starCount = Math.ceil(option.rating);
                }
                else if (option.id && option.id.includes('-')) {
                    const fromValue = parseFloat(option.id.split('-')[0]);
                    starCount = Math.ceil(fromValue);
                }
                else {
                    starCount = Math.floor(parseFloat(option.id));
                }
                const starText = starCount === 1 ? 'Star' : 'Stars';
                acc.push({
                    filterId: filter.id,
                    filterLabel: filter.label,
                    value: option.id,
                    valueLabel: `${starCount} ${starText}`,
                });
            });
        }
        else {
            const selectedOptions = ((_c = filter.options) === null || _c === void 0 ? void 0 : _c.filter((opt) => opt.selected)) || [];
            selectedOptions.forEach((option) => {
                acc.push({
                    filterId: filter.id,
                    filterLabel: filter.label,
                    value: option.id,
                    valueLabel: option.label,
                });
            });
        }
        return acc;
    }, []);
    if (activeFilters.length === 0) {
        return null;
    }
    function capitalizeFirstLetter(str) {
        if (str.length === 0) {
            return '';
        }
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return (h("div", { className: styles.activeFilters },
        activeFilters.map(({ filterId, filterLabel, value, valueLabel }) => {
            let label = valueLabel;
            if (valueLabel.includes(":")) {
                label = valueLabel.split(':')[1];
            }
            return (h("div", { key: `${filterId}-${value}`, className: styles.filterPill, onClick: () => onRemoveFilter(filterId, value), role: "button" },
                h("span", { className: styles.filterLabel }, capitalizeFirstLetter(label)),
                h("svg", { "aria-label": `Remove ${valueLabel} filter`, width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    h("path", { d: "M1 1L11 11M1 11L11 1", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }))));
        }),
        h("button", { className: styles.removeAllButton, onClick: onRemoveAllFilters, "aria-label": "Remove all filters" }, "Remove All")));
}
